module.exports = __webpack_public_path__ + "img/29.95edd1d7.jpg";